import React from 'react'
import ReactDOM from 'react-dom'
import { Providers } from 'components/providers'
import SignUpWizard from 'pages/signUpWizard'

const element = document.getElementById('root')

ReactDOM.render(
  <Providers>
    <SignUpWizard />
  </Providers>,
  element
)
